export interface currencyOptions {
  numberOfFractions?: number;
  withCurrency?: boolean;
}

export interface currencyWithGivenPrecisionOptions {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  withCurrency?: boolean;
}

export const formatCurrency = (number: number, opts?: currencyOptions): string => {
  const value = new Intl.NumberFormat("no-NB", {
    style: "currency",
    currency: "NOK",
    currencyDisplay: "name",
    minimumFractionDigits: opts?.numberOfFractions ?? 0,
    maximumFractionDigits: opts?.numberOfFractions ?? 0,
  }).format(number);

  return opts?.withCurrency
    ? value.replace(/norske kroner|norsk krone/, "NOK").trimEnd()
    : value.replace(/norske kroner|norsk krone/, "").trimEnd();
};

export const formatCurrencyWithGivenPrecision = (number: number, opts?: currencyWithGivenPrecisionOptions): string => {
  const value = new Intl.NumberFormat("no-NB", {
    style: "currency",
    currency: "NOK",
    currencyDisplay: "name",
    minimumFractionDigits: opts?.minimumFractionDigits ?? 0,
    maximumFractionDigits: opts?.maximumFractionDigits ?? 0,
  }).format(number);

  return opts?.withCurrency
    ? value.replace(/norske kroner|norsk krone/, "NOK").trimEnd()
    : value.replace(/norske kroner|norsk krone/, "").trimEnd();
};

export const formatNumber = (number: number, opts?: Intl.NumberFormatOptions | undefined) => {
  return new Intl.NumberFormat("no-NB", opts).format(number);
};

export const formatNumberTwoDigits = (number: number) => {
  return new Intl.NumberFormat("no-NB", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
};
